export default __webpack_public_path__ + "static/media/auto-renewal-background.1bf2ca97.jpg";